export const TYPE_SECURITY = 'Security';
export const TYPE_TAG = 'Tags';
export const TYPE_CONTENT = 'Content';
